import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/util/page";
import { Genre } from "./genre";

@Injectable()
export class GenreService {
  constructor(private httpClient: HttpClient) { }

  public findByNameFrLike(nameFr: string): Observable<Page<Genre>> {
    return this.httpClient.get<Page<Genre>>("/api/genre?size=50&nameFr=" + nameFr);
  }

  public findByThemaCode(themaCode: string): Observable<Genre> {
    return this.httpClient.get<Genre>("/api/genre/" + themaCode);
  }
}